import React, {useEffect, useState} from "react";
import { Alert } from "react-bootstrap";
import {hideMessage} from "../../store/reducers/message";

const AlertDismissible = ({
  textMessage,
  onAfterClose,
  variant = "warning",
}) => {
  const [show, setShow] = useState(true);

    useEffect(() => {

        const timer = setTimeout(() => {
           setShow(false)
        }, 5000);
        return () => clearTimeout(timer);

    }, [show]);

  const hide = () => {
    setShow(false);

    if (onAfterClose) {
      onAfterClose();
    }
  };

  if (show === true) {
    return (
      <Alert variant={variant} onClose={hide} dismissible>
        <p className="m-0">{textMessage}</p>
      </Alert>
    );
  }
};

export default AlertDismissible;
